import { APP_PERMISSIONS } from '@exam-center/permission';
import {
  ProctorRequestDetailsProvider,
  ProctorRequestHeader,
} from '@exam-center/proctor-request-details';
import { useParams } from '@exam-center/router';
import { Box } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function ProctorRequestDetailLayout() {
  const { requestId, examCenterCode } = useParams(
    '/:examCenterCode/exam-proctors/requests/:requestId',
  );

  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.PROCTOR_MANAGEMENT.PROCTOR_REQUEST.VIEW]}>
      <ProctorRequestDetailsProvider proctorRequestId={requestId} examCenterCode={examCenterCode}>
        <Box>
          <ProctorRequestHeader />
          <Outlet />
        </Box>
      </ProctorRequestDetailsProvider>
    </PermissionGuard>
  );
}
